import { appConfig } from '../../../../../config/customization';

export default {
  container: {
    width: '100%',
    backgroundColor: appConfig.colors.softBlue,
    display: 'flex',
    alignItems: 'center'
  }
};
